import { defineMessages, useIntl } from "react-intl";

import type { TravellerType } from "@/features/trips/types/types";

const labelMap = defineMessages({
  adultInDoubleRoom: {
    defaultMessage: "Adult in double room",
    description: "trips.travellersSelection.adultInDoubleRoom.title",
  },
  adultInSingleRoom: {
    defaultMessage: "Adult in single room",
    description: "trips.travellersSelection.adultInSingleRoom.title",
  },
  childWithBed: {
    defaultMessage: "Child with bed",
    description: "trips.travellersSelection.childWithBed.title",
  },
  childWithoutBed: {
    defaultMessage: "Child without bed",
    description: "trips.travellersSelection.childWithoutBed.title",
  },
  infant: {
    defaultMessage: "Infant",
    description: "trips.travellersSelection.infant.title",
  },
});

type Props = {
  rooms: Record<TravellerType, number>;
};

export function RoomList({ rooms }: Props) {
  const intl = useIntl();

  return (
    <ul className="space-y-1 text-sm font-medium text-text-primary">
      {Object.entries(rooms).map(([travellerType, count]) => {
        if (count === 0) return null;

        return (
          <li key={travellerType} className="text-sm">
            {count}x{" "}
            {intl.formatMessage(labelMap[travellerType as TravellerType])}
          </li>
        );
      })}
    </ul>
  );
}
